// extracted by mini-css-extract-plugin
module.exports = {"networks":"styles_networks__kAPOk","moreChainsIndicator":"styles_moreChainsIndicator__sdo1C"};